import { createDefaultSiteSettings as createDefaultAdminSiteSettings } from "./admin/pages/siteSettingsUtils";

export const createDefaultSiteSettings = () => createDefaultAdminSiteSettings();

export const normalizeSiteSettings = (settings = {}, defaults = createDefaultSiteSettings()) => ({
  ...defaults,
  ...settings,
  social_links: {
    ...(defaults.social_links || {}),
    ...(settings.social_links || {}),
  },
});

export const getSiteSettings = async (supabaseClient) => {
  if (!supabaseClient) return createDefaultSiteSettings();

  const { data, error } = await supabaseClient.from("site_settings").select("*").eq("key", "primary").maybeSingle();
  if (error) {
    return createDefaultSiteSettings();
  }

  return normalizeSiteSettings(data || {}, createDefaultSiteSettings());
};
